import BubbleCommon, {
  keywordDrillUrlPostEngagementTips,
  keywordDrillUrlCommentsEngagementTips,
  keywordDrillUrlPostEngagementTimeTips,
} from '@op/components/BubbleCommon';
import loading from '@op/models/loading';
import React from 'react';
import AnalysisCard from '../AnalysisCard';
import { useIntl } from 'umi';
import { Progress } from 'tea-component';
import { DBO_V } from '@op/utils/format';
import PercentageItem from '@op/components/Snippets/PercentageItem';

export function PostMetrics({ postEngagement, nearValue, ...cardProps }: any) {
  const { formatMessage } = useIntl();

  const StarRating = ({ detail }: any) => {
    return (
      <div className="dbo-mobile-rating-starbox">
        {[
          {
            text: 'Like',
            key: 'likes',
            ratioKey: 'likes_ratio',
            color: '#69D19C',
          },
          {
            text: 'Dislike',
            key: 'dislikes',
            ratioKey: 'dislikes_ratio',
            color: '#F17C86',
          },
          {
            text: 'Comments',
            key: 'comments',
            ratioKey: 'comments_ratio',
            color: '#6E7794',
          },
          {
            text: 'Share',
            key: 'shares',
            ratioKey: 'shares_ratio',
            color: '#F8D74D',
          },
        ].map(({ text, key, color, ratioKey }) => {
          const ratio = detail?.[ratioKey];
          const value = detail?.[key];

          return (
            <div key={text} className="dbo-mobile-rating-starbox-item">
              <div className="dbo-mobile-rating-top">
                <div>{formatMessage({ id: text })}</div>
                <span className="dbo-mobile-rating-top-value">
                  {DBO_V.reviews(value)}
                </span>
              </div>
              <Progress
                className={`dbo-mobile-rating-progress`}
                percent={ratio * 100}
                strokeWidth={6}
                strokeColor={color}
              />
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <AnalysisCard
      value={postEngagement.total}
      className="dbo-analysis-card--post-engagement"
      title={
        <BubbleCommon
          showIcon={false}
          placement="top"
          tipsMap={keywordDrillUrlPostEngagementTips}
        >
          {formatMessage({ id: 'Post Engagement' })}
        </BubbleCommon>
      }
      nearValue={
        nearValue
        // <BubbleCommon tipsMap={keywordDrillUrlPostEngagementTimeTips}>
        //   {nearValue}
        // </BubbleCommon>
      }
      footer={<StarRating detail={postEngagement} />}
      loading={loading}
      formatPercentValue={(value) => DBO_V.reviews(value)}
      {...cardProps}
    />
  );
}

export function CommentsMetrics({
  commentsEngagement,
  nearValue,
  ...cardProps
}: any) {
  const { formatMessage } = useIntl();

  return (
    <AnalysisCard
      className="dbo-analysis-card--comment-engagement"
      value={commentsEngagement.total}
      title={
        <BubbleCommon
          showIcon={false}
          placement="top"
          tipsMap={keywordDrillUrlCommentsEngagementTips}
        >
          {formatMessage({ id: 'Comments Engagement' })}
        </BubbleCommon>
      }
      formatValue={(value) => DBO_V.reviews(value)}
      nearValue={nearValue}
      footer={
        <div className="dbo-analysis-mention-card">
          <>
            {formatMessage({ id: 'Positive%' })}
            <PercentageItem
              percentage={commentsEngagement.positive || 0}
              showIcon={false}
              formateFunc={DBO_V.ratio}
              className="success"
            />
          </>
          <>
            {formatMessage({ id: 'Negative%' })}
            <PercentageItem
              percentage={commentsEngagement.negative || 0}
              showIcon={false}
              formateFunc={DBO_V.ratio}
              className="error"
            />
          </>
        </div>
      }
      loadingHeight={57}
      {...cardProps}
    />
  );
}
